import { atom } from 'jotai';
import { Environments } from '../constants/environment.js';

const baseUrlTrackingApiAtom = atom(Environments.production);
baseUrlTrackingApiAtom.debugLabel = 'kitbag.tracking.baseUrlTrackingApi';

export { baseUrlTrackingApiAtom, baseUrlTrackingApiAtom as default };
//# sourceMappingURL=config.js.map
